import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.css';

type Props = {
  className?: string;
};

export const WisoryLabel = ({ className, children }: React.PropsWithChildren<Props>) => {
  return <p className={clsx(styles.label, className)}>{children}</p>;
};
